var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoader = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 112"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 374",
    x: 78,
    width: 4,
    height: 32,
    rx: 2,
    fill: "#E5E4EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 375",
    x: 78,
    y: 128,
    width: 4,
    height: 32,
    rx: 2,
    fill: "#E5E4EC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 113"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 374_2",
    x: 98.7734,
    y: 2.20703,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(15 98.7734 2.20703)",
    fill: "#E5E4EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 375_2",
    x: 65.6445,
    y: 125.846,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(15 65.6445 125.846)",
    fill: "#E5E4EC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 114"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 374_3",
    x: 118.268,
    y: 9.71875,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(30 118.268 9.71875)",
    fill: "#E5E4EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 375_3",
    x: 54.2676,
    y: 120.57,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(30 54.2676 120.57)",
    fill: "#E5E4EC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 115"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 374_4",
    x: 135.154,
    y: 22.0156,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(45 135.154 22.0156)",
    fill: "#E5E4EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 375_4",
    x: 44.6445,
    y: 112.525,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(45 44.6445 112.525)",
    fill: "#E5E4EC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 116"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 374_5",
    x: 148.281,
    y: 38.2676,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(60 148.281 38.2676)",
    fill: "#E5E4EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 375_5",
    x: 37.4297,
    y: 102.268,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(60 37.4297 102.268)",
    fill: "#E5E4EC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 117"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 374_6",
    x: 156.756,
    y: 57.3633,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(75 156.756 57.3633)",
    fill: "#E5E4EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 375_6",
    x: 33.1172,
    y: 90.4922,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(75 33.1172 90.4922)",
    fill: "#E5E4EC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 118"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 374_7",
    x: 160,
    y: 78,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(90 160 78)",
    fill: "#E5E4EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 375_7",
    x: 32,
    y: 78,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(90 32 78)",
    fill: "#E5E4EC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 119"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 374_8",
    x: 157.791,
    y: 98.7734,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(105 157.791 98.7734)",
    fill: "#E5E4EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 375_8",
    x: 34.1523,
    y: 65.6445,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(105 34.1523 65.6445)",
    fill: "#E5E4EC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 120"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 374_9",
    x: 150.281,
    y: 118.268,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(120 150.281 118.268)",
    fill: "#E5E4EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 375_9",
    x: 39.4297,
    y: 54.2676,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(120 39.4297 54.2676)",
    fill: "#E5E4EC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 121"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 374_10",
    x: 137.982,
    y: 135.154,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(135 137.982 135.154)",
    fill: "#E5E4EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 375_10",
    x: 47.4727,
    y: 44.6445,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(135 47.4727 44.6445)",
    fill: "#E5E4EC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 374_11",
    x: 121.732,
    y: 148.281,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(150 121.732 148.281)",
    fill: "#E5E4EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 375_11",
    x: 57.7324,
    y: 37.4297,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(150 57.7324 37.4297)",
    fill: "#E5E4EC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 123"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 374_12",
    x: 102.639,
    y: 156.758,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(165 102.639 156.758)",
    fill: "#E5E4EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 375_12",
    x: 69.5098,
    y: 33.1191,
    width: 4,
    height: 32,
    rx: 2,
    transform: "rotate(165 69.5098 33.1191)",
    fill: "#E5E4EC"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector 162 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.435 63.8787C102.606 65.0503 102.606 66.9497 101.435 68.1213L75.6994 93.8568L58.8788 77.0385C57.7072 75.867 57.707 73.9675 58.8785 72.7958C60.05 71.6242 61.9495 71.6241 63.1212 72.7956L75.6991 85.3718L97.1922 63.8787C98.3638 62.7071 100.263 62.7071 101.435 63.8787Z",
    fill: "url(#paint0_linear_422_20723)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_422_20723",
    x1: 80.1568,
    y1: 63,
    x2: 80.1568,
    y2: 93.8568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52B921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93D724"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoader);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loader.c6fbbd7d5b9a85fc9eb93e43cb4bf479.svg";